<template>
  <div class="app-container">
    <div class="title-container">
      <div>兑换记录列表</div>
      <p>查看已审核后的兑换订单，支持订单预览和发货处理。</p>
    </div>

    <div class="filter-container">
      <el-input
        v-model="listQuery.userId"
        placeholder="会员ID"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.orderNo"
        placeholder="订单编号"
        style="width: 200px"
        class="filter-item"
        clearable
      />

      <el-select
        v-model="listQuery.status"
        placeholder="订单状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in ORDER_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <DataPicker
        @valueFunc="getPickerValueFunc"
        startPlaceholder="支付开始时间"
        endPlaceholder="支付截止时间"
      />
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" prop="userId" label="会员ID" width="190"></el-table-column>
      <el-table-column align="center" prop="orderNo" label="订单编号" width="190"></el-table-column>
      <el-table-column label="联系姓名" align="center" prop="name" width="110"></el-table-column>
      <el-table-column label="联系电话" align="center" prop="phone" width="120"></el-table-column>

      <el-table-column class-name="status-col" label="状态" align="center" width="120">
        <template slot-scope="scope">
          <el-tag :color="getValue(ORDER_STATUS_CSS, scope.row.status)" style="color: #FFFFFF"
            >{{ getValue(ORDER_STATUS, scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="商品名称"
        width="200"
        prop="title"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.items[0].title }}
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="支付数字积分"
        align="buyDeductionValue"
        width="120"
      />
      <el-table-column
        class-name="status-col"
        label="支付人民币"
        prop="payAmount"
        align="center"
        width="120"
      >
        <template slot-scope="scope"> ¥{{ scope.row.payAmount }} </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="支付方式" align="center" width="100">
        <template slot-scope="scope">
          <el-tag>{{ getValue(ORDER_PAY_PLATFORM, scope.row.payPlatform) }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" prop="payTime" label="支付时间" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time" v-if="scope.row.payTime" />
          <span>{{ formatApiDate(scope.row.payTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="120"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            plain
            @click="!scope.row.isAfter && checkShipmentsVisible(true, scope.row)"
            class="comm_but_warp"
            :disabled="![2].includes(scope.row.status) || scope.row.isAfter"
            >发货</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    发货-->
    <el-dialog
      title="发货"
      :visible.sync="shipmentsVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form
        ref="form"
        :rules="goodsFules"
        :model="goodsForm"
        label-position="left"
        label-width="150px"
        style="width: 90%; margin-left:50px;"
      >
        <el-form-item label="实物商品" prop="refId">
          <el-table
            ref="multipleTable"
            :data="goodsList"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            size="mini"
            v-loading="goodsListLoading"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="id" label="商品编号" width="80"> </el-table-column>
            <el-table-column prop="title" label="商品名称"> </el-table-column>
            <el-table-column prop="mainGraph" label="商品图" width="100">
              <template slot-scope="scope">
                <el-image
                  style="width: 50px; height: 50px"
                  :src="scope.row.mainGraph"
                  fit="cover"
                ></el-image>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="快递公司" prop="expressld">
          <el-select
            v-model="goodsForm.expressId"
            placeholder="请选择快递公司"
            style="width: 100%"
            class="filter-item"
            clearable
            filterable
          >
            <el-option
              v-for="item in shippingCompanyOption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="快递单号" prop="expressNo">
          <el-input v-model="goodsForm.expressNo" placeholder="请输入" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkShipmentsVisible(false, {})">取消</el-button>
        <el-button type="primary" @click="shipmentsOk" :loading="shipmentsBtnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getOrderList, auditOrder, getGoodsList, deliveryFeedback } from "@/api/order";
import { getExpress } from "@/api/common";
import { formatApiDate } from "@/utils/utils";
import {
  getValue,
  ORDER_STATUS,
  AUDIT_STATUS,
  AUDIT_STATUS_TYPE,
  ORDER_PAY_PLATFORM
} from "@/utils/enumUtile";
import { ORDER_STATUS_CSS } from "@/utils/enumUtileCss";
import DataPicker from "@/views/components/dataPicker.vue";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    ORDER_STATUS_CSS() {
      return ORDER_STATUS_CSS;
    },
    AUDIT_STATUS() {
      return AUDIT_STATUS;
    },
    AUDIT_STATUS_TYPE() {
      return AUDIT_STATUS_TYPE;
    },
    ORDER_PAY_PLATFORM() {
      return ORDER_PAY_PLATFORM;
    },
    ORDER_STATUS() {
      return ORDER_STATUS;
    }
  },
  components: { DataPicker },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        orderNo: null,
        userId: null,
        status: null
      },
      shipmentsVisible: false,
      orderInfo: {},
      shipmentsBtnLoading: false,
      auditRemark: "",
      goodsForm: {
        id: 0,
        itemIds: null,
        expressId: null, // 快递公司ID
        expressNo: null // 快递单号
      },
      shippingCompanyOption: [], // 发货公司
      goodsList: [],
      goodsListLoading: false
    };
  },
  created() {
    const savedState = sessionStorage.getItem("pageState");
    // 只有当 savedState 存在且是有效的 JSON 字符串时才恢复状态
    if (savedState) {
      const parsedState = JSON.parse(savedState);
      // 确保解析后的数据是对象类型
      if (parsedState && typeof parsedState === "object") {
        this.listQuery = { ...this.listQuery, ...parsedState };
      }
    }
    sessionStorage.removeItem("pageState");
    this.getList();
  },
  watch: {},
  methods: {
    getValue,
    /**
     * 查询发货公司
     */
    getShippingCompany() {
      getExpress().then(resp => {
        if (resp && resp.bizcode === 100) {
          this.shippingCompanyOption = resp.data;
        }
      });
    },
    /**
     * 查询订单详情
     */
    getGoodsList(id) {
      this.goodsListLoading = true;
      const params = {
        id
      };
      getGoodsList(params)
        .then(resp => {
          this.goodsList = resp.data;
        })
        .finally(() => {
          this.goodsListLoading = false;
        });
    },
    // 发货 start
    checkShipmentsVisible(status, item) {
      if (status) {
        this.goodsForm.id = item.id;
        this.getShippingCompany();
        this.getGoodsList(item.id);
      } else {
        this.goodsForm.id = 0;
        this.goodsList = [];
        this.$refs.form.resetFields();
      }
      this.shipmentsVisible = status;
    },
    /**
     * 选择发货商品
     * @param item
     */
    handleSelectionChange(item) {
      this.goodsForm.itemIds = item.map(o => o.id).join(",");
    },
    shipmentsOk() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const form = this.goodsForm;
          if (!form.itemIds) {
            this.$notify({
              title: "提示",
              message: "请选择需要发货的商品",
              type: "warning",
              duration: 1500
            });
            return;
          }
          const params = {
            ...form
          };
          this.shipmentsBtnLoading = true;
          deliveryFeedback(params)
            .then(resp => {
              if (resp && resp.bizcode === 100) {
                this.getList();
                this.checkShipmentsVisible(false);
                this.$notify({
                  title: "成功",
                  message: "发货成功",
                  type: "success",
                  duration: 2000
                });
              }
            })
            .finally(() => {
              this.shipmentsBtnLoading = false;
            });
        }
      });
    },

    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },

    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form,
        auditType: 1
      };
      getOrderList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    handleAuditPass(item) {
      this.orderInfo = item;
      this.auditRemark = "";
      this.shipmentsVisible = true;
    },

    handleAuditResult(type) {
      this.shipmentsBtnLoading = true;
      const params = {
        id: this.orderInfo.id,
        auditType: type,
        remark: this.auditRemark
      };
      auditOrder(params)
        .then(resp => {
          if (resp && resp.bizcode === 100) {
            this.orderInfo = {};
            this.auditRemark = "";
            this.shipmentsVisible = false;
            this.getList();
            this.$notify({
              title: "成功",
              message: type === 1 ? "审核通过" : "审核驳回",
              type: "success",
              duration: 2000
            });
          }
        })
        .finally(() => {
          this.shipmentsBtnLoading = false;
        });
    },
    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(value) {
      this.listQuery.payStartTime = value[0];
      this.listQuery.payEndTime = value[1];
    }
  }
};
</script>
<style scoped lang="scss">
.title-container {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: bold;

  p {
    font-size: 14px;
    color: #909399;
    margin-top: 5px;
    font-weight: normal;
  }
}

.comm_but_warp {
  margin-bottom: 10px;
}

.filter-container {
  display: flex;
  /* 使用 flex 布局 */
  flex-wrap: wrap;
  /* 允许内容换行 */
  align-items: center;
  /* 垂直居中对齐 */
  gap: 10px;
  /* 元素之间的间距（现代浏览器支持） */
  margin-bottom: 20px;
  flex-direction: row;

  // 针对 filter-item 的统一样式
  .filter-item {
    margin-bottom: 0 !important;
    /* 清除默认的底部边距，由 gap 或容器控制 */
    flex-shrink: 0;
    /* 禁止压缩内容长度 */
  }
}

.comm_but_warp {
  margin-bottom: 5px;
}

.card_content {
  display: flex;
  flex-direction: column;
}
</style>
